import { defineMessages } from 'react-intl'

export default defineMessages({
  searchPlaceholder: {
    id: 'containers.CustomerOrdersPage.searchPlaceholder',
    defaultMessage: 'Search by order #, project or e-mail..',
  },
  noResultsQuery: {
    id: 'containers.CustomerOrdersPage.noResultsQuery',
    defaultMessage: 'No results for ',
  },
  noResultsFilters: {
    id: 'containers.CustomerOrdersPage.noResultsFilters',
    defaultMessage: 'No results with selected filters',
  },
  of: {
    id: 'containers.CustomerOrdersPage.of',
    defaultMessage: 'of',
  },
  edit: {
    id: 'containers.CustomerOrdersPage.edit',
    defaultMessage: 'Edit',
  },
  newOrder: {
    id: 'containers.CustomerOrdersPage.newOrder',
    defaultMessage: 'New order',
  }
})
